<template>
<div class="content-i">

    <div class="content-box">
        <div class="element-wrapper">
            <div class="element-actions d-none d-sm-block">
                <a class="btn btn-primary btn-sm" v-if="is_active_session == 0">
                    <i class="os-icon os-icon-ui-22"></i>
                    <router-link tag="span" :to="`/photodesk/session/add`">
                        Add Session
                    </router-link>
                </a>
            </div>
            <h6 class="element-header">
                Photo Desk Sessions
            </h6>
            <Loader v-if="isLoading" />
                <EmptyState v-else-if="sessions.length == 0" >
                    <div slot="empty_state_text">
                        No Sessions
                    </div>
                </EmptyState>
            <div class="element-box" v-else>
                <div class="table-responsive">
                    <table class="table table-striped table-lightborder">
                        <thead>
                            <tr>
                                <th>Session ID</th>
                                <th>Status</th>
                                <th>Channel</th>
                                <th>Type</th>
                                <th>Reporting Class</th>
                                <th>Location</th>
                                <th>Contributors</th>
                                <th>Products</th>
                                <th>Dropped</th>
                                <th>Created</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody >

                            <tr v-for="session in sessions" :key="session.id_photodesk_session">
                                <td class="nowrap">
                                    {{session.code}}
                                </td>
                                <td class="nowrap capitalize" :class="formatStatus(session.status)">
                                    {{formatStatus(session.status)}}
                 
                                </td>
                                <td class="nowrap"><img :src="session.channel_logo" height="16px" alt=""></td>
                                <td class="nowrap capitalize">{{session.type}} </td>
                                <td class="nowrap capitalize"> {{session.reporting_class || 'General' }}</td>
                                <td class="nowrap capitalize">{{session.location_name_en}}</td>
                                <td>
                                    <div class="cell-image-list">
                                        <div v-for="contributor in formatContributors(session)" class="cell-img" :style="'background-image: url('+contributor.avatar+')'"></div>
                                    </div>
                                </td>
                                <td>
                                    <h3>{{session.product_count}}</h3>

                                </td>
                                <td>
                                    <h3 :class="{'text-danger': session.dropped_count > 0}">
                                        <span v-if="session.dropped_count > 0">{{session.dropped_count}}</span>
                                        <span v-else>-</span>
                                    </h3>

                                </td>
                                <td>
                                    {{session.created_at}}
                                </td>
                                <td>
                                    <router-link tag="a" :to="`/photodesk/sessions/${session.id_photodesk_session}`">
                                        View
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getSessions()" :offset="5" ></Pagination>
        </div>

    </div>
</div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import CommonFunctions from '@/mixins/common-functions.js'
import TableLoader from '@/components/common/TableLoader'
import Loader from '@/components/common/Loader'

export default {
  name: 'session-list',
  mixins: [CommonFunctions],
  components: { TableLoader, Loader, Pagination },
  data () {
    return {
      isLoading: true,
      sessions: [],
      is_active_session: 0,
      pagination: {
        'current_page': 1
      },
      statusFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Open', 'key': '1' },
        { 'name': 'Closed', 'key': '0' },
        { 'name': 'Cancelled', 'key': '3' },
        { 'name': 'Importing', 'key': '4' },
        { 'name': 'Processing', 'key': '5' }
      ]
    }
  },
  mounted: function () {
    this.getSessions()
  },
  methods: {
    getSessions: function () {
      var self = this
      const url = '/photodesk/sessions?page=' + this.pagination.current_page
      self.isLoading = true
      this.$http.get(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.sessions = response.data.sessions.data
          self.is_active_session = response.data.is_active_session
          self.pagination = response.data.sessions
          self.isLoading = false
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    },
    addSession: function () {
      var self = this
      const url = '/photodesk/session/add'
      let data = {
        id_channel: 6,
        shoot_type: 'product'
      }

      self.$store.dispatch('updateLoading', 'true')

      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.$store.dispatch('updateLoading', 'false')
          self.$router.push('/photodesk/sessions/' + response.data.session.id_photodesk_session)
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    }
  }
}
</script>

<style scoped>
    .open {
        color:#75da62 !important;
    }
    .closed {
        color: #23b7e5!important;
    }
    .processing {
        color: #a59904!important
    }
    .cancelled {
        color: #ddd;
    }
</style>
